<template>
  <div class="c-bg--gray--pc c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div class="c-common-inner">
        <TheTemplateN
          :key="inputScreenKey"
          heading :indicated-item="['search']"
          search-placeholder="贈る人検索"
          :search-button-color="colorCode"
          :error-message="searchErrorMessage"
          @search-change="onSearchChange"
          @do-search="searchUser"
          @show-search-suggest="showSearchSuggest"
        >
          <template #searchSuggest>
            <div
              v-if="
                searchResult &&
                showSuggest &&
                availableUsers.length === 0 &&
                availableGroups.length === 0"
                class="p-search-suggest p-search-suggest--message"
            >
              検索結果対象者はすべて選択済みです。
            </div>
            <div v-if="searchResult && showSuggest && (availableUsers.length > 0 || availableGroups.length > 0)"
              class="p-search-suggest" @click.stop>
              <div
                v-if="canSelectGroup && availableGroups.length"
                class="p-search-suggest__title"
              >
                グループ
              </div>
              <template v-if="canSelectGroup">
                <div
                  v-for="group in availableGroups"
                  :key="group.groupId"
                  class="p-search-group"
                >
                  <button
                    class="p-search-group__header"
                    @click.stop="toggleGroup(group.groupId)"
                  >
                    <div
                      class="p-search-group__left"
                      :title="`コード：${group.groupCode}`">
                      <span>
                        {{ expandedGroups[group.groupId] ? "▼" : "▶" }}
                      </span>
                      <span class="p-search-group__name" data-translate-skip>
                        {{ group.groupName }}
                      </span>
                      <span>
                        （{{ group.userCount }}）
                      </span>
                    </div>
                    <button
                      v-if="isSp"
                      type="button"
                      class="p-search-suggest__info"
                      @click.stop="showGroupInfo(group)"
                    >
                      ⓘ
                    </button>
                  </button>
                  <div
                    v-if="expandedGroups[group.groupId]"
                    class="p-search-group__users"
                  >
                    <button
                      class="p-search-group__select-all"
                      @click.stop="selectGroup(group)"
                    >
                      このグループ所属全員を選択
                    </button>
                    <button
                      v-for="user in getGroupUsers(group.groupId)"
                      :key="user.userId"
                      class="p-search-group__user"
                      @click.stop="selectUser(user)"
                    >
                      <img
                        v-if="user.userImage"
                        :src="user.userImage"
                        class="p-search-suggest__avatar"
                        alt=""
                      >
                      <div class="p-search-suggest__user-info">
                        <div class="p-search-suggest__user-name" data-translate-skip>
                          {{ user.userName }}
                        </div>
                        <div class="p-search-suggest__user-employee-id" data-translate-skip>
                          {{ user.usingEmployeeId }}　{{ user.groupName }}
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </template>
              <div v-if="availableUsers.length" class="p-search-suggest__title">
                贈る人
              </div>
              <button
                v-for="user in availableUsers"
                :key="user.userId"
                :title="`グループ：${user.groupName}（${user.groupCode}）`"
                class="p-search-suggest__user"
                @click.stop="selectUser(user)"
              >
                <div class="p-search-suggest__user-content">
                  <img
                    v-if="user.userImage"
                    :src="user.userImage"
                    class="p-search-suggest__avatar"
                    alt=""
                  >
                  <div class="p-search-suggest__user-info">
                    <div class="p-search-suggest__user-name" data-translate-skip>
                      {{ user.userName }}
                    </div>
                    <div class="p-search-suggest__user-employee-id" data-translate-skip>
                      {{ user.usingEmployeeId }}　{{ user.groupName }}
                    </div>
                  </div>
                  <button
                    v-if="isSp"
                    type="button"
                    class="p-search-suggest__info"
                    @click.stop="showUserInfo(user)"
                  >
                    ⓘ
                  </button>
                </div>
              </button>
            </div>
          </template>
          <template #beforeSearch>
            <div
              v-if="selectedUsers.length > 0"
              class="p-selected-users-wrapper"
            >
              <div class="p-selected-users__header">
                <span class="p-the-j-input-screen__label">
                  贈る人
                </span>
                <div v-if="selectedUsers.length > 1" class="p-selected-users__actions">
                  <span class="p-selected-users__count">
                    {{ selectedUsers.length }}/{{ maxSelectableUsers }}名
                  </span>
                  <button
                    class="p-selected-users__clear"
                    @click="clearSelectedUsers"
                  >
                    すべて解除
                  </button>
                </div>
              </div>
              <div class="p-selected-users">
                <div
                  v-for="user in displayUsers"
                  :key="user.userId"
                  class="p-selected-users__chip"
                  @click.stop="showUserInfo(user)"
                  :title="`ID：${user.usingEmployeeId}
グループ：${user.groupName}（${user.groupCode}）`"
                >
                  <template v-if="!isDefaultUserImage(user.userImage)">
                    <img
                      :src="user.userImage"
                      class="p-selected-users__avatar-image"
                      alt=""
                    >
                  </template>
                  <template v-else>
                    <div
                      class="p-selected-users__avatar"
                      :style="{backgroundColor: getGroupColor(user.groupName)}" data-translate-skip
                    >
                      {{ user.groupName?.trim().split(/[\s　]+/).slice(0, 2).map(word => word.charAt(0)).join("") || "?" }}
                    </div>
                  </template>
                  <span class="p-selected-users__name" data-translate-skip>
                    {{ user.userName }}
                  </span>
                  <button
                    class="p-selected-users__remove"
                    @click.stop="removeUser(user.userId)"
                  >
                    ×
                  </button>
                </div>
                <div
                  v-if="showModal"
                  class="p-modal-overlay"
                  @click="showModal = false"
                >
                  <div
                    class="p-modal"
                    @click.stop
                  >
                    <div class="p-modal__header">
                      {{ modalTitle }}
                    </div>
                    <div class="p-modal__body">
                      {{ modalMessage }}
                    </div>
                    <div class="p-modal__footer">
                      <button
                        class="p-modal__button"
                        :style="{ background: colorCode }"
                        @click="showModal = false"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  v-if="showConfirmModal"
                  class="p-modal-overlay"
                  @click="showConfirmModal = false"
                >
                  <div
                    class="p-confirm-modal"
                    @click.stop
                  >
                    <div class="p-modal__header">
                      入力内容確認
                    </div>
                    <div class="p-modal__body">
                      <div class="p-confirm-row">
                        <div class="p-confirm-label">
                          贈る人
                        </div>
                        <div class="p-selected-users">
                          <div
                            v-for="user in confirmDisplayUsers"
                            :key="user.userId"
                            class="p-selected-users__chip"
                          >
                            <template v-if="!isDefaultUserImage(user.userImage)">
                              <img
                                :src="user.userImage"
                                class="p-selected-users__avatar-image"
                                alt=""
                              >
                            </template>
                            <template v-else>
                              <div
                                class="p-selected-users__avatar"
                                :style="{backgroundColor: getGroupColor(user.groupName)}" data-translate-skip
                              >
                                {{ user.groupName?.trim().split(/[\s　]+/).slice(0, 2).map(word => word.charAt(0)).join("") || "?" }}
                              </div>
                            </template>
                            <span class="p-selected-users__name" data-translate-skip>
                              {{ user.userName }}
                            </span>
                          </div>
                        </div>
                        <div class="p-selected-users__footer">
                          <button
                            v-if="!confirmShowAllUsers && confirmHiddenUserCount > 0"
                            class="p-selected-users__toggle"
                            @click="confirmShowAllUsers = true"
                          >
                            + {{ confirmHiddenUserCount }}名
                          </button>
                          <button
                            v-if="confirmShowAllUsers && selectedUsers.length > 9"
                            class="p-selected-users__toggle"
                            @click="confirmShowAllUsers = false"
                          >
                            閉じる
                          </button>
                        </div>
                      </div>
                      <div class="p-confirm-row">
                        <div
                          v-if="selectedGiftBadge"
                          class="p-confirm-row"
                        >
                          <div class="p-confirm-label">
                            バッジ
                          </div>
                          <div class="p-confirm-badge">
                            <img
                              :src="selectedGiftBadge.icon"
                              class="p-confirm-badge__icon"
                              alt=""
                            >
                            <span data-translate-skip>
                              {{ selectedGiftBadge.name }}
                            </span>
                          </div>
                        </div>
                        <div class="p-confirm-point">
                          <div class="p-confirm-label">
                            {{
                              selectedUsers.length > 1
                                ? "合計送付ポイント"
                                : "送付ポイント"
                            }}
                          </div>
                          <template v-if="selectedUsers.length === 1">
                            <PointNotation
                              :font-size="24"
                              :point="confirmData.sendPoint"
                              :sign-is-exists="false"
                            />
                          </template>
                          <template v-else>
                            <div class="p-confirm-point-formula">
                              <PointNotation
                                :font-size="24"
                                :point="confirmData.sendPoint"
                                :sign-is-exists="false"
                              />
                              <span class="p-confirm-point-formula__operator">
                                × {{ selectedUsers.length }}
                                <span class="p-confirm-point-formula__unit">名</span>
                              </span>
                              <span class="p-confirm-point-formula__operator">
                                =
                              </span>
                              <PointNotation
                                :font-size="24"
                                :point="usedPoints"
                                :sign-is-exists="false"
                              />
                            </div>
                          </template>
                        </div>
                      </div>
                      <div class="p-confirm-row">
                        <div class="p-confirm-label">
                          タイトル
                        </div>
                        <div class="p-confirm-title" data-translate-skip>
                          {{ confirmData.title }}
                        </div>
                      </div>
                      <div class="p-confirm-row">
                        <div class="p-confirm-label">
                          本文
                        </div>
                        <div class="p-confirm-message" data-translate-skip>
                          {{ confirmData.message }}
                        </div>
                      </div>
                    </div>
                    <div class="p-modal__footer">
                      <button
                        class="p-confirm-cancel"
                        @click="showConfirmModal = false"
                      >
                        戻る
                      </button>
                      <button
                        class="p-modal__button"
                        :style="{ background: colorCode }"
                        @click="sendThanksPoint"
                      >
                        上記内容で贈る
                     </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-selected-users__footer">
                <button
                  v-if="!showAllUsers && hiddenUserCount > 0"
                  class="p-selected-users__toggle"
                  @click="showAllUsers = true"
                >
                  + {{ hiddenUserCount }}名
                </button>
                <button
                  v-if="showAllUsers && selectedUsers.length > 9"
                  class="p-selected-users__toggle"
                  @click="showAllUsers = false"
                >
                  閉じる
                </button>
              </div>
            </div>
          </template>
          <template #header>
            <CommonHeading>贈与内容入力</CommonHeading>
          </template>
          <template #contents>
            <div class="p-the-page-j09">
              <div class="p-the-page-j09__body">

                <div
                  v-if="showGiftBadge"
                  class="p-gift-badge"
                >
                  <FormLabel for="badge" :required="giftBadgeRequired">バッジ</FormLabel>
                  <div
                    class="p-gift-badge__dropdown"
                  >
                    <button
                      type="button"
                      class="p-gift-badge__selected"
                      @click="isBadgeDropdownOpen = !isBadgeDropdownOpen"
                    >
                      <div class="p-gift-badge__value">
                        <template v-if="selectedGiftBadge">
                          <img
                            :src="selectedGiftBadge.icon"
                            class="p-gift-badge__icon"
                            alt=""
                          >
                          <span data-translate-skip>
                            {{ selectedGiftBadge.name }}
                          </span>
                        </template>
                        <template v-else>
                          <span class="p-gift-badge__placeholder">{{ noSelectBadge }}</span>
                        </template>
                      </div>
                      <span class="p-gift-badge__arrow">
                        {{ isBadgeDropdownOpen ? "▲" : "▼" }}
                      </span>
                    </button>
                    <div
                      v-if="isBadgeDropdownOpen"
                      class="p-gift-badge__menu"
                    >
                      <button
                        type="button"
                        class="p-gift-badge__option"
                        @click="clearGiftBadge"
                      >
                        <span class="p-gift-badge__placeholder">未設定</span>
                      </button>
                      <button
                        v-for="badge in giftBadges"
                        :key="badge.id"
                        type="button"
                        class="p-gift-badge__option"
                        @click="selectGiftBadge(badge)"
                      >
                        <img
                          :src="badge.icon"
                          class="p-gift-badge__icon"
                          alt=""
                        >
                        <span data-translate-skip>
                          {{ badge.name }}
                        </span>
                      </button>
                    </div>
                  </div>
                  <div
                    class="p-search-help-wrapper"
                    @mouseenter="showBadgeTooltipPc"
                    @mouseleave="hideBadgeTooltipPc"
                  >
                    <div
                      class="p-search-help"
                      @click.stop="toggleBadgeTooltip"
                    >
                    ⓘ
                    </div>
                    <div
                      v-if="showBadgeTooltip && !isSp"
                      class="p-search-help__tooltip"
                      @click.stop
                    >
                      贈りたい内容に合ったバッジを選択できます。<br>
                      ※バッジに設定された内容が自動入力されます。入力済みの内容は上書きされません。
                    </div>
                  </div>

                  <div
                    v-if="showBadgeTooltip && isSp"
                    class="p-help-modal-overlay"
                    @click="showBadgeTooltip = false"
                  >
                    <div
                      class="p-help-modal"
                      @click.stop
                    >
                      <div class="p-help-modal__body">
                        贈りたい内容に合ったバッジを選択できます。<br>
                        ※バッジに設定された内容が自動入力されます。入力済みの内容は上書きされません。
                      </div>
                    </div>
                  </div>
                </div>


                <TheJInputScreen
                  ref="inputScreen"
                  :key="inputScreenKey"
                  :available-points="availablePoints"
                  :points-to-send="pointsToSend"
                  :max-points="maxPoints"
                  :min-points="minPoints"
                  :giving-type="thanksMessageType"
                  :default-message="defaultMessage"
                  :fixed-point="fixedPoint"
                  :used-points="usedPoints"
                  :selected-user-count="selectedUsers.length"
                  :gift-badge-required="giftBadgeRequired"
                  :selected-gift-badge-id="selectedGiftBadgeId"
                  :title-edit-enabled="titleEditEnabled"
                  @send-point-change="sendPoint = $event"
                  @show-confirm="openConfirmModal"
                />
              </div>
            </div>
          </template>
        </TheTemplateN>
      </div>
    </div>
    <TheFooter />
    <div
      v-if="selectedGroupInfo"
      class="p-user-info-modal-overlay"
      @click.stop="selectedGroupInfo = null"
    >
      <div
        class="p-user-info-modal"
        @click.stop
      >
        <div>
          <span data-translate-skip>コード：{{ selectedGroupInfo.groupCode }}</span>
        </div>
      </div>
    </div>
    <div v-if="selectedUserInfo" 
      class="p-user-info-modal-overlay"
      @click.stop="closeUserInfo"
    >
      <div
        class="p-user-info-modal"
        @click.stop
      >
        <div>ID：<span data-translate-skip>{{ selectedUserInfo.usingEmployeeId }}</span></div>
        <div>グループ：<span data-translate-skip>{{ selectedUserInfo.groupName }}（{{ selectedUserInfo.groupCode }}）</span></div>
      </div>
    </div>
    <ModalCompletedThanksPointSend
      v-if="completedModalType === 1"
      :modal-complete-data="completedModalData"
      :heading="'承認依頼しました'"
      @close="closeCompletedModal"
    >
      <template #text>
        現在、<span data-translate-skip>{{ thanksPointName }}</span>は承認待ちです。
      </template>
    </ModalCompletedThanksPointSend>
    <ModalCompletedThanksPointSend
      v-else-if="completedModalType === 2"
      :modal-complete-data="completedModalData"
      :heading="thanksPointName + 'を送付しました'"
      @close="closeCompletedModal"
    >
      <template #text>
        送付内容はポイント確認ページからご確認いただけます。
      </template>
    </ModalCompletedThanksPointSend>
  </div>
  <LoadingProcess />
</template>

<script lang="ts">
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";

import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";

import ModalCompletedThanksPointSend from "@/general/components/organisms/ModalCompletedThanksPointSend.vue";
import TheTemplateN from "@/general/components/templates/TheTemplateN.vue";
import TheJInputScreen from "@/general/components/pages/parts/GiveThanksPoint/TheJInputScreen.vue";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import globals from "@/general/store/modules/globals";
import { GiveThanksPoints } from "@/general/store/models";
import ThanksPointApi from "@/general/api/thanksPointApi";
import sitemap from "@/general/mixins/const/custom/sitemap";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";
import { ListResponse, ThanksPointUserSelect } from "@/general/store/models";
import loginInfo from "@/general/store/modules/loginInfo";
import AuthApi from "@/general/api/authApi";
import FormLabel from "@/common/components/organisms/FormLabel.vue";

type ApiErrorResponse = {
  isError: true;
  status?: number;
  data?: any;
};

type ApiResult<T> = ListResponse<T> | ApiErrorResponse;

@Options({
  components: {
    TheHeader,
    TheFooter,
    CommonHeading,
    TheTemplateN,
    TheJInputScreen,
    PointNotation,
    ModalCompletedThanksPointSend,
    FormLabel
  }
})
export default class GiveThanksPoint extends Vue {

  ssoFlg = false;
  thanksPointGive: any = {};
  baseKeyword = "";
  originalSearchResult: any = null;
  searchResult: any = null;
  showSuggest = false;
  sendPoint = 0;
  maxSelectableUsers = 1;
  selectedUsers: any[] = [];
  selectedGroupInfo: any = null;
  selectedUserInfo: any = null;
  showAllUsers = false;
  confirmShowAllUsers = false;
  modalTitle = "";
  modalMessage = "";
  showModal = false;
  searchErrorMessage = "";
  showConfirmModal = false;
  completedModalType = 0;
  completedModalData!: any;
  inputScreenKey = 0;
  isSending = false;
  expandedGroups: Record<number, boolean> = {};
  matchedUserIds: number[] = [];
  userImageCache = new Map<number, string>();
  giftBadges: any[] = [];
  selectedGiftBadgeId: number | null = null;
  isBadgeDropdownOpen = false;
  selectedGiftBadge: any = null;
  showBadgeTooltip = false;

  confirmData = {
    sendPoint: "",
    title: "",
    message: ""
  };

  breadcrumb: any = [
    {
      text: "",
      url: sitemap.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "贈与内容入力",
      url: "",
      pageType: "lower"
    }
  ];

  declare $refs: {
    theHeader: TheHeader;
    inputScreen: TheJInputScreen;
  };

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }


  get availablePoints() {
    return this.thanksPointGive.available_point;
  }

  get pointsToSend() {
    return this.activePointSource.selectedPoint;
  }

  get maxPoints() {
    return this.activePointSource.maxPoint;
  }

  get minPoints() {
    return this.activePointSource.minPoint;
  }

  get fixedPoint() {
    return this.activePointSource.fixedPoint;
  }

  get thanksMessageType() {
    return this.activePointSource.giftPointPattern;
  }

  get defaultMessage() {
    return auth.user?.default_thanks_message || "";
  }

  get activePointSource() {
    if (this.selectedGiftBadge && this.selectedGiftBadge.giftPointPattern !== 9) {
      return this.selectedGiftBadge;
    }

    return this.defaultPointSource;
  }

  selectUser(user: any) {
    if (this.isSingleSelect) {
      this.selectedUsers = [user];
      this.showSuggest = false;
      return;
    }

    const exists = this.selectedUsers.some(
      (u) => u.userId === user.userId
    );

    if (exists) {
      return;
    }

    if (this.selectedUsers.length >= this.maxSelectableUsers) {
      this.showSuggest = false;
      this.modalTitle = "選択上限";
      this.modalMessage = `選択可能人数は${this.maxSelectableUsers}名までです。`;
      this.showModal = true;
      return;
    }

    this.selectedUsers.push(user);

    this.searchErrorMessage = "";
  }

  selectGroup(group: any) {
    const users = this.originalSearchResult
      .thanksPointUserSelectionDatas
      .filter(
        (user: any) =>
          user.groupId === group.groupId
      );

    const targetUsers = users.filter(
      (user: any) =>
        !this.selectedUsers.some(
          (selected: any) =>
            selected.userId === user.userId
        )
    );

    const remain = this.maxSelectableUsers - this.selectedUsers.length;

    if (targetUsers.length <= remain) {
      this.selectedUsers.push(...targetUsers);
      return;
    }

    const addUsers = targetUsers.slice(0, remain);

    const excludedUsers = targetUsers.slice(remain);

    this.selectedUsers.push(...addUsers);

    this.modalTitle = "選択上限";

    const displayUsers = excludedUsers
      .slice(0, 10)
      .map((user: any) => `${user.userName}`)
      .join("\n");

    this.modalMessage =
`${group.groupName}　${targetUsers.length}名中
${addUsers.length}名を追加しました。

以下の${excludedUsers.length}名は選択上限(${this.maxSelectableUsers}名)を超えるため追加されませんでした。
${displayUsers}

${
  excludedUsers.length > 10
    ? `他 ${excludedUsers.length - 10}名`
    : ""
}`;
  this.showSuggest = false;
  this.showModal = true;
 }

  removeUser(userId: number) {
    this.selectedUsers =
      this.selectedUsers.filter(
        user => user.userId !== userId
      );
    if (
      this.selectedUserInfo &&
      this.selectedUserInfo.userId === userId
    ) {
      this.selectedUserInfo = null;
    }
  }

  showSearchSuggest() {
    if (this.searchResult) {
      this.showSuggest = true;
    }
  }

  closeCompletedModal() {
    this.completedModalType = 0;
  }

  handleOutsideClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
  
    if (!target.closest(".p-search-suggest")
        && !target.closest(".p-the-template-j__search")) {
      this.showSuggest = false;
    }

    if (!target.closest(".p-gift-badge")) {
      this.isBadgeDropdownOpen = false;
    }
  }
  
  mounted() {
    AuthStorage.checkLogin();

    document.addEventListener(
      "click",
      this.handleOutsideClick
    );
    
  }

  beforeUnmount() {
    document.removeEventListener(
      "click",
      this.handleOutsideClick
    );
  }

  async created() {
    this.ssoFlg = loginInfo.isSso;
    const response: GiveThanksPoints = await ThanksPointApi.getGiveThanksPoints();

    this.giftBadges = response?.profilesGiftBadgeDatas ?? [];

    this.thanksPointGive = {
      min_points: response?.minPoints ? response?.minPoints : 0,
      max_points: response?.maxPoints ? response?.maxPoints : 0,
      points_to_send: response?.pointsToSend ? response?.pointsToSend : "",
      available_point: response?.giftPoints ? response?.giftPoints : 0,
      thanks_point_pattern: response?.thanksPointPattern
        ? response?.thanksPointPattern
        : 0,
      fixed_point: response?.fixedPoint ? response?.fixedPoint : 0,
      giftBadgeRequired: response?.giftBadgeRequired ?? false
    };

    const userDetails = LocalStorage.getItem("userDetails");
    if (userDetails) {
      const userDetailsJson = JSON.parse(userDetails);
      if (!userDetailsJson.thanks_point_enabled) {
          window.location.href = "/home";
      }
      this.maxSelectableUsers = userDetailsJson.maxGiftUsers || 1;
    } else {
      window.location.href = "/home";
    }

    await commons.setOrgPageSpecificDataFromLocalStorage();
    await commons.setbreadcrumb(this.breadcrumb);

    const partnerUserId = Number(LocalStorage.getItem("partnerUserId"));
    if (partnerUserId > 0) {
      await this.setPartnerUser(partnerUserId);
      LocalStorage.removeItem("partnerUserId");
    }
  }

  async sendThanksPoint() {

    if (this.isSending) {
      return;
    }

    await globals.setLoadingProcess(true);
    this.isSending = true;
    try {
      const payload = {
        userIds: this.selectedUsers.map(
          user => user.userId
        ),
        sendPoint: Number(this.confirmData.sendPoint),
        title: this.confirmData.title,
        message: this.confirmData.message,
        giftBadgeId: this.selectedGiftBadgeId
      };
  
      let result = false;
      let validErrMsg = "";
      let res;
  
      try {
        res = await ThanksPointApi.postThanksPoint(payload);
        result = res.result;
        validErrMsg = res.validErrMsg;
      } catch (e: any) {
        console.log(e.error);
      }
  
      if (res && res.status == 500) {
        if (this.ssoFlg) {
          // SSOログイン時は行き止まりエラー画面へ
          window.location.href = "/session-time-out/";
        } else {
          LocalStorage.removeAll();
          AuthApi.getLogout();
          auth.remove();
          window.location.href = "/system-error/";
        }
      }
  
      if (!result) {
        alert(validErrMsg);
        return;
      }
  
      this.completedModalData = {
        sendTo: {
          name:
            this.selectedUsers.length === 1
              ? this.selectedUsers[0].userName
              : `${this.selectedUsers.length}名`,
          icon: {
            medium: res.iconImage
          }
        },
        selectedUserCount: this.selectedUsers.length,
        sendPoint:
          this.selectedUsers.length > 1
            ? this.usedPoints
            : Number(this.confirmData.sendPoint)
      };

      this.showConfirmModal = false;
      const userDetails = LocalStorage.getItem("userDetails");
      if (userDetails) {
        const userDetailsJson = JSON.parse(userDetails);
        this.completedModalType = userDetailsJson.thanks_point_approval_enabled ? 1 : 2;
      }

      // 選択ユーザー初期化
      this.selectedUsers = [];
      this.selectedUserInfo = null;
      this.searchResult = null;

      // モーダル関連初期化
      this.showAllUsers = false;
      this.confirmShowAllUsers = false;

      // 入力内容初期化
      this.confirmData = {
        sendPoint: "",
        title: "",
        message: ""
      };

      this.selectedGiftBadge = null;
      this.selectedGiftBadgeId = null;
      this.isBadgeDropdownOpen = false;

      this.sendPoint = 0;
      this.inputScreenKey++;

      // 検索候補閉じる
      this.showSuggest = false;

      // エラーメッセージクリア
      this.searchErrorMessage = "";

      const response = await ThanksPointApi.getGiveThanksPoints();
      this.thanksPointGive = {
        min_points: response?.minPoints ?? 0,
        max_points: response?.maxPoints ?? 0,
        points_to_send: response?.pointsToSend ?? "",
        available_point: response?.giftPoints ?? 0,
        thanks_point_pattern: response?.thanksPointPattern ?? 0,
        fixed_point: response?.fixedPoint ?? 0
      };
      await this.$refs.theHeader.refreshHeaderInfo();
    } finally {
      this.isSending = false;
      await globals.setLoadingProcess(false);
    }
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }

  async searchUser(keyword: string) {
    this.matchedUserIds = [];
    await globals.setLoadingProcess(true);
    try {
      const keywords = keyword.trim().split(/\s+/);
      const firstKeyword = keywords[0];
  
      if (!keyword || !keyword.trim()) {
        this.searchErrorMessage = "検索キーワードを入力してください";
        this.showSuggest = false;
        this.searchResult = null;
        return;
      }
  
      if (
        this.originalSearchResult &&
        keywords.length > 1 &&
        firstKeyword === this.baseKeyword
      ) {
        this.filterSearchResult(keyword);
        return;
      }
  
      this.searchErrorMessage = "";
  
      try {
        const res = (await ThanksPointApi.getThanksPointUserSelection(firstKeyword)) as ApiResult<ThanksPointUserSelect>;
  
        if (!("results" in res) || !res.results?.length) {
          this.searchErrorMessage =
            "贈る人が見つかりません";
          this.showSuggest = false;
          return;
        }
  
        const data: any = res.results[0];
  
        if (data.thanksPointUserSelectionDatas.length === 0) {
          this.searchErrorMessage =
            "贈る人が見つかりません";
  
          this.showSuggest = false;
          return;
        }

        data.thanksPointUserSelectionDatas = data.thanksPointUserSelectionDatas.map(
         (user: any) => ({
            ...user,
            userImage:
            this.userImageCache.get(
              user.userId
            ) ?? ""
         })
       );

        this.originalSearchResult = data;
        this.baseKeyword = firstKeyword;
 
        const MAX_SEARCH_USERS = 1000;
        if (data.thanksPointUserSelectionDatas.length > MAX_SEARCH_USERS) {
          this.searchErrorMessage = `検索結果が${MAX_SEARCH_USERS}件を超えています。検索条件を追加してください。`;
          this.searchResult = null;
          this.showSuggest = false;
          return;
        }

        this.searchResult = data;
        this.expandedGroups = {};

        this.searchErrorMessage = "";

        if (keywords.length > 1) {
          this.filterSearchResult(keyword);
        } else {
          this.matchedUserIds = [];
          this.searchErrorMessage = "";
          this.showSuggest = true;
          this.loadUserImages(data.thanksPointUserSelectionDatas);
        }
      } catch (error) {
        console.error("贈る人検索エラー", error);
      }
    } finally {
      await globals.setLoadingProcess(false);
    }
  }

  get availableGroups() {
    return (
      this.searchResult?.thanksPointGroupSelectionDatas
        ?.filter((group: any) =>
          this.getGroupUsers(
            group.groupId
          ).length > 0
        )
        .sort(
          (a: any, b: any) =>
            a.groupCode.localeCompare(
              b.groupCode,
              "ja"
            )
        ) || []
    );
  }

  get availableUsers() {
    let users =
      this.searchResult?.thanksPointUserSelectionDatas || [];

    if (this.canSelectGroup) {
      const groupIds = new Set(
        this.searchResult?.thanksPointGroupSelectionDatas
        ?.map((g: any) => g.groupId)
    );
    users = users.filter(
      (user: any) => {
        const matchedByUser =
          this.matchedUserIds.includes(
            user.userId
          );
        if (matchedByUser) {
          return true;
        }
        return !groupIds.has(
          user.groupId
        );
      }
    );
  }

    return users
      .filter(
        (user: any) =>
          !this.selectedUsers.some(
            selected =>
              selected.userId === user.userId
          )
      )
      .sort(
        (a: any, b: any) =>
          a.usingEmployeeId.localeCompare(
            b.usingEmployeeId,
            "ja"
          )
      );
  }

  getGroupUsers(groupId: number) {
    return (
      this.originalSearchResult
        ?.thanksPointUserSelectionDatas
        ?.filter(
          (user: any) =>
            user.groupId === groupId
        )
        .filter(
          (user: any) =>
            !this.selectedUsers.some(
              (selected: any) =>
                selected.userId === user.userId
            )
        )
        .sort(
          (a: any, b: any) =>
            a.usingEmployeeId.localeCompare(
              b.usingEmployeeId,
              "ja"
            )
        ) || []
    );
  }

  showGroupInfo(group: any) {
    this.selectedGroupInfo = group;
  }

  showUserInfo(user: any) {
    this.selectedUserInfo = user;
  }

  closeUserInfo() {
    this.selectedUserInfo = null;
  }

  filterSearchResult(keyword: string) {
    if (!this.originalSearchResult) {
      return;
    }
    const keywords = keyword
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    const users =
      this.originalSearchResult
        .thanksPointUserSelectionDatas
        .filter((user: any) => {
          return keywords.every(
            (word: string) => {
              const userTarget =
                [
                  user.userName,
                  user.usingEmployeeId
                ]
                  .join(" ")
                  .toLowerCase();
              const groupTarget =
                [
                  user.groupName,
                  user.groupCode
                ]
                  .join(" ")
                  .toLowerCase();
              return (
                userTarget.includes(
                  word.toLowerCase()
                )
                ||
                groupTarget.includes(
                  word.toLowerCase()
                )
              );
            }
          );
        });

        const MAX_SEARCH_USERS = 1000;
        if (users.length > MAX_SEARCH_USERS) {
          this.searchErrorMessage = `検索結果が${MAX_SEARCH_USERS}件を超えています。検索条件を追加してください。`;
          this.showSuggest = false;
          this.searchResult = null;
          return;
        }

    this.matchedUserIds =
      users
        .filter((user: any) =>
          keywords.some(
            (word: string) =>
              user.userName
                .toLowerCase()
                .includes(
                  word.toLowerCase()
                )
              ||
              user.usingEmployeeId
                .toLowerCase()
                .includes(
                  word.toLowerCase()
                )
          )
        )
        .map(
          (user: any) =>
            user.userId
        );
    const groups =
      this.originalSearchResult
        .thanksPointGroupSelectionDatas
        .filter((group: any) => {
          const target = [
            group.groupName,
            group.groupCode
          ]
            .join(" ")
            .toLowerCase();
          return keywords.every(
            (word: string) =>
              target.includes(
                word.toLowerCase()
              )
          );
        });
    this.searchResult = {
      ...this.originalSearchResult,
      thanksPointUserSelectionDatas: users,
      thanksPointGroupSelectionDatas: groups
    };

    const hasResult =
      users.length > 0 ||
    groups.length > 0;

    if (!hasResult) {
      this.searchErrorMessage =
      "贈る人が見つかりません";

      this.showSuggest = false;

      return;
    }

    this.searchErrorMessage = "";
    this.showSuggest = true;
    this.loadUserImages(users);
  }

  getGroupColor(groupName: string) {
  
    let hash = 0;
  
    for (let i = 0; i < groupName.length; i++) {
      hash =
        groupName.charCodeAt(i) +
        ((hash << 5) - hash);
    }
  
    const hue = Math.abs(hash) % 360;
  
    return `hsl(${hue}, 65%, 85%)`;
  }

  get displayUsers() {
    if (this.showAllUsers) {
      return this.selectedUsers;
    }
    return this.selectedUsers.slice(0, 9);
  }

  get hiddenUserCount() {
    return Math.max(
      this.selectedUsers.length - 9,
      0
    );
  }

  clearSelectedUsers() {
    this.selectedUsers = [];
    this.selectedUserInfo = null;
    this.showAllUsers = false;
  }

  get usedPoints() {
    return (
      this.sendPoint * this.selectedUsers.length
    );
  }

  get canSelectGroup() {
    return this.maxSelectableUsers > 1;
  }

  get isSingleSelect() {
    return this.maxSelectableUsers === 1;
  }

  get colorCode() {
    return commons.colorCode;
  }

  openConfirmModal(data: any) {

    this.confirmData = data;
    this.confirmShowAllUsers = false;
    this.showConfirmModal = true;
  }

  get confirmDisplayUsers() {
    if (this.confirmShowAllUsers) {
      return this.selectedUsers;
    }
    return this.selectedUsers.slice(0, 9);
  }

  get confirmHiddenUserCount() {
    return Math.max(
      this.selectedUsers.length - 9, 0
    );
  }

  onSearchChange(keyword: string) {
    this.matchedUserIds = [];
    if (!keyword.trim()) {
      this.searchResult = null;
      this.originalSearchResult = null;
      this.showSuggest = false;
      this.searchErrorMessage = "";
      this.baseKeyword = "";
      this.expandedGroups = {};
    }
  }

  async setPartnerUser(partnerUserId: number) {
    try {
      await globals.setLoadingProcess(true);
      const res = await ThanksPointApi.getThanksPointUserSelectionByUserId(partnerUserId) as ApiResult<ThanksPointUserSelect>;

      if (!("results" in res) || !res.results?.length) {
        return;
      }

      const data: any = res.results[0];
      const user = data.thanksPointUserSelectionDatas?.[0];

      if (!user) {
        return;
      }
      this.selectUser(user);
    } finally {
      await globals.setLoadingProcess(false);
    }
  }

  toggleGroup(groupId: number) {
    this.expandedGroups[groupId] = !this.expandedGroups[groupId];
  }

  isDefaultUserImage(userImage?: string) {
    return (
      !userImage ||
      userImage === "/static/img/user-icon.png"
    );
  }

  async loadUserImages(users: any[]) {
    const targetUserIds = users
      .map(user => user.userId)
      .filter(
        (userId: number) =>
          !this.userImageCache.has(userId)
      );

    if (targetUserIds.length === 0) {
      return;
    }

    const chunkSize = 100;
    const chunks: number[][] = [];

    for (let i = 0; i < targetUserIds.length; i += chunkSize) {
      chunks.push(targetUserIds.slice(i, i + chunkSize));
    }

    Promise.allSettled(
      chunks.map(ids =>
        ThanksPointApi.getThanksUsersInfo(ids)
      )
    ).then(responses => {
      responses.forEach(response => {
        if (response.status !== "fulfilled") {
          return;
        }
        response.value.results?.forEach(user => {
          this.userImageCache.set(
            user.id,
            user.user_image
          );
        });
      });

      if (this.originalSearchResult) {
        this.originalSearchResult = {
          ...this.originalSearchResult,
          thanksPointUserSelectionDatas:
            this.originalSearchResult.thanksPointUserSelectionDatas.map(
              (user: any) => ({
                ...user,
                userImage:
                  this.userImageCache.get(
                    user.userId
                  ) ?? ""
              })
            )
        };
      }

      if (this.searchResult) {
        this.searchResult = {
          ...this.searchResult,
          thanksPointUserSelectionDatas:
            this.searchResult.thanksPointUserSelectionDatas.map(
              (user: any) => ({
                ...user,
                userImage:
                  this.userImageCache.get(
                    user.userId
                  ) ?? ""
              })
            )
        };
      }

    });
  }

  get showGiftBadge() {
    return this.giftBadges.length > 0;
  }

  selectGiftBadge(badge: any) {
    const beforePoint = this.$refs.inputScreen?.getCurrentSendPoint();
    this.selectedGiftBadge = badge;
    this.selectedGiftBadgeId = badge.id;

    this.$nextTick(() => {
      this.applyGiftPointPattern(
        badge,
        beforePoint
      );

      this.$refs.inputScreen?.setBadgeContent(
        badge.title,
        badge.message
      );
    });

    this.isBadgeDropdownOpen = false;
  }

  clearGiftBadge() {
    const beforePoint = this.$refs.inputScreen?.getCurrentSendPoint();

    this.$refs.inputScreen?.setBadgeContent(
      "",
      "",
      true
    );

    this.selectedGiftBadge = null;
    this.selectedGiftBadgeId = null;

    this.$nextTick(() => {
      this.applyGiftPointPattern(
        this.defaultPointSource,
        beforePoint
      );
    });
    this.isBadgeDropdownOpen = false;
  }

  get giftBadgeRequired() {
    return this.thanksPointGive.giftBadgeRequired ?? false;
  }

  get noSelectBadge() {
      return this.giftBadgeRequired ? "バッジを選択してください" : "未設定"
  }

  applyGiftPointPattern(badge: any, beforePoint: any) {
    const inputScreen = this.$refs.inputScreen as any;

    if (!inputScreen) {
      return;
    }

    const point = beforePoint;
    const hasPoint = point !== null && point !== undefined && point !== "";

    switch (badge.giftPointPattern) {
      case 0:
        inputScreen.setSendPoint(
          Number.isNaN(Number(point))
            ? ""
            : point
        );
        break;

      case 1:
        {
          const options = JSON.parse(badge.selectedPoint ?? "[]");
          const pointString = String(point)
          const exists = options.includes(Number(pointString));
          inputScreen.setSendPoint(
            exists ? pointString : options[0] ?? ""
          );
          break;
        }

      case 2:
        inputScreen.setSendPoint(badge.fixedPoint);
        break;

      case 3:
        {
          if (!hasPoint) {
            inputScreen.setSendPoint("");
            break;
          }

          const min = badge.minPoint;
          const max = badge.maxPoint;
          const inRange = Number(point) >= min && Number(point) <= max;
          inputScreen.setSendPoint(inRange ? point : "");
          break;
        }

      case 9:
        this.applyGiftPointPattern(
          this.defaultPointSource,
          beforePoint
        );
      break;
    }
  }

  get titleEditEnabled() {
    return this.selectedGiftBadge?.titleEditEnabled ?? true;
  }

  get defaultPointSource() {
    return {
      giftPointPattern: this.thanksPointGive.thanks_point_pattern,
      selectedPoint: this.thanksPointGive.points_to_send,
      fixedPoint: this.thanksPointGive.fixed_point,
      minPoint: this.thanksPointGive.min_points,
      maxPoint: this.thanksPointGive.max_points
    };
  }

  showBadgeTooltipPc() {
    if (!this.isSp) {
      this.showBadgeTooltip = true;
    }
  }

  hideBadgeTooltipPc() {
   if (!this.isSp) {
     this.showBadgeTooltip = false;
    }
  }

  toggleBadgeTooltip() {
    if (this.isSp) {
      this.showBadgeTooltip = !this.showBadgeTooltip;
    }
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-j09-header {
  @include pc {
    margin-left: rem(-48);
  }

  display: flex;
  align-items: center;

}

.p-the-page-j09 {
  @include pc {
    width: cal(576, 1080);
    min-width: rem(576);
    padding: rem(0) 0 rem(8);
  }
  margin: 0 auto;

  &__body {
    margin-top: rem(20);
  }
}

.p-search-suggest {
  position: absolute;

  top: 100%;
  left: 0;

  width: 100%;

  transform: none;

  z-index: 1000;

 background: #fff;

  box-shadow:
    0 8px 24px rgba(0, 0, 0, .12);

  border: 1px solid rgba(0, 0, 0, .08);

  max-height: 300px;
  overflow-y: auto;
}

.p-search-suggest__user {
  display: block;

  width: 100%;

  padding: 12px 16px;

  text-align: left;

  border: none;

  background: #fff;

  cursor: pointer;
}

.p-search-suggest__user:hover {
  background: #f5f5f5;
}
.p-search-suggest__title {
  padding: 8px 12px;

  font-size: 12px;
  font-weight: bold;

  color: #666;
  background: #f5f5f5;
}

.p-search-suggest__user-name {
  font-size: 14px;
  font-weight: 700;
}

.p-search-suggest__user-employee-id {
  margin-top: 2px;

  font-size: 11px;

  color: #666;
}

.p-user-info-modal-overlay {
  position: fixed;
  inset: 0;

  background: rgba(0, 0, 0, .4);

  z-index: 1999;
}

.p-user-info-modal {
  position: fixed;

  left: 50%;
  top: 50%;

  transform: translate(-50%, -50%);

  z-index: 2000;

  min-width: 240px;

  padding: 16px;

  border-radius: 8px;

  background: #fff;

  box-shadow: 0 8px 24px rgba(0, 0, 0, .2);
}
.p-search-suggest__user-content {
  display: flex;

  align-items: center;

  justify-content: space-between;
}

.p-search-suggest__user-info {
  flex: 1;
}

.p-search-suggest__info {

  margin-left: 8px;

  border: none;

  background: transparent;

  color: #0078d4;

  font-size: 16px;

  cursor: pointer;
}
.p-selected-users {
  display: flex;

  flex-wrap: wrap;

  gap: 8px;

  margin-bottom: 16px;
}

.p-selected-users__chip {
  display: flex;

  align-items: center;

  gap: 4px;

  padding: 2px 8px 2px 2px;

  min-height: 28px;

  border-radius: 16px;

  background: #f3f2f1;
}

.p-selected-users__avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  object-fit: cover;
  flex-shrink: 0;
}

.p-selected-users__name {
  font-size: 14px;
}

.p-selected-users__remove {
  display: flex;

  align-items: center;
  justify-content: center;

  width: 18px;
  height: 18px;

  border-radius: 50%;
}

.p-selected-users__remove:hover {
  background: #d1d1d1;
}
.p-the-j-input-screen {
  &__label {
    @include sp {
      font-size: rem(14);
    }
    line-height: 2.5;
    font-weight: bold;
    margin-right: 0.5em;
    display: block;
  }
}

.p-selected-users__footer {
  display: flex;

  justify-content: flex-end;

  margin-top: 8px;
}

.p-selected-users__toggle {
  border: none;

  background: transparent;

  color: #6264a7;

  font-weight: 600;

  cursor: pointer;
}

.p-selected-users__header {
  display: flex;

  align-items: center;

  justify-content: space-between;

  margin-bottom: 8px;
}
.p-selected-users__actions {
  display: flex;

  align-items: center;

  gap: 12px;
}
.p-selected-users__count {
  font-size: 12px;

  color: #666;
}

.p-selected-users__clear {
  padding: 4px 12px;

  border: none;
  border-radius: 16px;

  background:#73767a;
  color: #fff;

  font-size: 12px;
  font-weight: 600;

  cursor: pointer;
}

.p-selected-users__clear:hover {
  opacity: .9;
}

.p-selected-users__clear:hover {
  text-decoration: underline;
}
.p-selected-users__header {
  @include sp {
    flex-direction: column;

    align-items: flex-start;

    gap: 4px;
  }
}
.p-modal-overlay {
  position: fixed;
  inset: 0;

  background: rgba(0, 0, 0, .4);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 1000;
}

.p-modal {
  width: 500px;

  max-width: calc(100vw - 32px);

  max-height: 80vh;

  display: flex;
  flex-direction: column;

  background: #fff;

  border-radius: 8px;

  overflow: hidden;

  box-shadow: 0 8px 24px rgba(0, 0, 0, .2);
}

.p-modal__header {
  padding: 16px 20px;

  font-size: 18px;
  font-weight: 700;

  border-bottom: 1px solid #edebe9;
}

.p-modal__body {
  padding: 24px 20px;

  line-height: 1.8;

  white-space: pre-line;

  overflow-y: auto;

  max-height: 60vh;
}

.p-modal__footer {
  padding: 16px 20px;

  border-top: 1px solid #edebe9;

  text-align: right;
}

.p-modal__button {
  min-width: 120px;
  min-height: 40px;

  border: none;

  border-radius: 20px;

  color: #fff;

  font-weight: 700;

  cursor: pointer;
}

.p-modal__button:hover {
  opacity: .9;
}
.p-confirm-modal {
  width: 800px;

  max-width: calc(100vw - 32px);

  max-height: 80vh;

  display: flex;
  flex-direction: column;

  background: #fff;

  border-radius: 8px;

  overflow: hidden;

  @media (max-width: 375px) and (max-height: 700px) {
      margin-top: 20px;
  }

}

.p-confirm-row {
  margin-bottom: 24px;
}

.p-confirm-label {
  font-weight: 700;

  margin-bottom: 8px;
}

.p-confirm-cancel {
  min-width: 120px;
  min-height: 40px;

  margin-right: 12px;

  border: 1px solid #ccc;

  border-radius: 20px;

  background: #fff;

  cursor: pointer;
}

.p-confirm-title,
.p-confirm-message {

  padding: 16px;

  background: #f3f2f1;

  border-radius: 8px;

  white-space: pre-wrap;

  line-height: 1.8;

}

.p-confirm-point-formula {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.p-confirm-point-formula__operator {
  white-space: nowrap;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}

.p-confirm-point-formula__unit {
  font-size: 12px;
  font-weight: 400;
}

.p-search-group {
  border-bottom: 1px solid #eee;
}

.p-search-group__header {
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 12px 16px;

  border: none;

  background: #fff;

  text-align: left;

  cursor: pointer;
}

.p-search-group__header:hover {
  background: #f5f5f5;
}

.p-search-group__left {
  display: flex;
  align-items: center;

  gap: 4px;
}

.p-search-group__name {
  font-weight: 700;
}

.p-search-group__users {
  background: #fafafa;
}

.p-search-group__user {
  display: flex;
  align-items: center;
  width: 100%;

  padding: 8px 32px;

  border: none;

  background: transparent;

  text-align: left;

  cursor: pointer;
}

.p-search-group__user:hover {
  background: #f3f2f1;
}

.p-search-group__select-all {
  width: 100%;

  padding: 8px 32px;

  border: none;

  border-top: 1px solid #e5e5e5;

  background: #fff;

  color: #6264a7;

  font-weight: 700;

  cursor: pointer;
}

.p-selected-users-wrapper {
  max-width: rem(576);
  width: 100%;
  margin: 0 auto 2rem;
}

.p-search-suggest--message {
  padding: 16px;

  color: #666;

  text-align: center;

  font-size: 14px;
}

.p-search-suggest__avatar {
  width: 32px;
  height: 32px;

  margin-right: 8px;

  border-radius: 50%;

  object-fit: cover;

  flex-shrink: 0;
}

.p-selected-users__avatar-image {
  width: 28px;
  height: 28px;

  border-radius: 50%;

  object-fit: cover;

  display: block;

  flex-shrink: 0;
}

.p-gift-badge {
  position: relative;
  max-width: rem(576);
  margin: 0 auto rem(24);

  &__label {
    @include sp {
      font-size: rem(14);
    }
    line-height: 1.5;
    font-weight: bold;
    margin-right: 0.5em;
    display: block;
  }

  &__selected {
    width: 100%;
    height: rem(40);

    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 0 rem(12);

    border: 1px solid #ccc;
    background: #fff;
  }

  &__menu {
    position: absolute;
    top: 100%;
    left: 0;

    width: 100%;

    background: #fff;
    border: 1px solid #ccc;

    z-index: 100;
  }

  &__option {
    width: 100%;

    display: flex;
    align-items: center;

    gap: rem(8);

    padding: rem(8) rem(12);

    background: #fff;

    color: #000;
  }

  &__option:hover {
    background: #f5f5f5;
  }

  &__icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  &__placeholder {
    color: #999;
  }

  &__value {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
.p-confirm-badge {
  display: flex;
  align-items: center;
  gap: 8px;

  &__icon {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
  }
}
.p-search-help-wrapper {
  @include pc {
    position: absolute;
    left: calc(100% + 8px);
    top: 50%;
    transform: translateY(50%);
    z-index: 20;
  }
}
.p-search-help {
  color: #6264a7;
  font-size: 16px;
  cursor: pointer;

  @include sp {
    position: absolute;
    right: 0;
    left: auto;
    top: 7px;
  }
}
.p-search-help__tooltip {
  position: absolute;

  width: 240px;
  padding: 8px 12px;

  background: #333;
  color: #fff;

  border-radius: 4px;

  font-size: 12px;
  line-height: 1.5;

  z-index: 2000;

  @include pc {
    left: calc(100% + 8px);
    top: 0;
  }

  @include sp {
    left: 0;
    top: calc(100% + 5px);
  }
}
.p-help-modal-overlay {
  position: fixed;
  inset: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(0, 0, 0, .4);

  z-index: 3000;
}

.p-help-modal {
  width: 300px;
  max-width: calc(100vw - 32px);

  background: #fff;
  border-radius: 8px;

  overflow: hidden;

  box-shadow: 0 8px 24px rgba(0, 0, 0, .2);
}

.p-help-modal__body {
  padding: 12px;

  line-height: 1.8;
}
</style>
